import React, { useCallback, useLayoutEffect, useRef, useState, forwardRef, useImperativeHandle } from 'react';
import styled from 'styled-components';

const AnimateTab = forwardRef(({ tabs, onClick, className, initIndex }, ref) => {
  const containerRef = useRef();
  const sliderRef = useRef();
  const [activeIndex, setActiveIndex] = useState(initIndex || 0);

  useImperativeHandle(ref, () => {
    return {
      setIndex: (index) => {
        if (index !== activeIndex) {
          setActiveIndex(index)
          handleAnimate(index);
        }
      }
    }
  })

  const handleTabClick = (index) => {
    if (index === activeIndex) {
      return;
    }
    setActiveIndex(index);
    handleAnimate(index);
    onClick && onClick(index);
  };

  const handleAnimate = (index) => {
    const parentWidth = containerRef.current.clientWidth;
    const basic = 0;
    const sliderWidth = parentWidth / tabs.length;
    const nextPosition = (index * sliderWidth + basic).toFixed(2) + 'px';
    sliderRef.current.style.left = nextPosition;
  };

  const setIndicator = useCallback(() => {
    const parentWidth = containerRef.current.clientWidth;
    const sliderWidth = (parentWidth / tabs.length).toFixed(2) + 'px';
    sliderRef.current.style.width = sliderWidth;
  }, []);

  useLayoutEffect(() => {
    setIndicator();
    window.addEventListener('resize', setIndicator);
    return () => {
      window.removeEventListener('resize', setIndicator);
    };
  }, []);

  return (
    <Container ref={containerRef} className={className || ''}>
      <div className="animate-tab-wrap">
        {tabs.map((item, index) => (
          <div
            onClick={() => handleTabClick(index)}
            key={item}
            className={'animate-tab-item' + (activeIndex === index ? ' animate-tab-active' : '')}
          >
            {item}
          </div>
        ))}
      </div>

      <div className="animate-slider" ref={sliderRef} />
    </Container>
  );
});

export default React.memo(AnimateTab);

const Container = styled.div`
  position: relative;
  border-radius: 16px;
  height: 38px;
  .animate-tab-wrap {
    display: flex;
    flex-direction: row;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
  }
  .animate-tab-item {
    font-size: 15px;
    font-weight: 500;
    color: #292929;
    flex: 1;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10;
  }
  .animate-tab-active {
    color: #FFFFFF;
  }
  .animate-slider {
    background:linear-gradient(266deg, #FF7200 0%, #FFAE00 99%);
    height: 38px;
    position: absolute;
    z-index: 9;
    transition: left 0.1s;
    border-radius: 8px; 
  }
`;



// WEBPACK FOOTER //
// ./src/views/activity_42/components/tabs.js